import { Crud, HttpClient, httpClient } from 'lib/HttpClient';
import { RuleSearchType } from './rules.types';

class RulesApi extends Crud {
    constructor(client: HttpClient) {
        super(client, import.meta.env.API_SERVER_URL, 'rules', {
            'x-auth-id': import.meta.env.CONSOLE_FIREBASE_PROJECT_ID
        });
    }
    public getGraph() {
        const headers = {
            'x-auth-id': import.meta.env.CONSOLE_FIREBASE_PROJECT_ID
        };
        return this.httpClient.post(`${this.api}/rules/graph`, { headers });
    }
    public validate() {
        const headers = {
            'x-auth-id': import.meta.env.CONSOLE_FIREBASE_PROJECT_ID
        };
        return this.httpClient.post(`${this.api}/rules/validate`, { headers });
    }
    public searchRules(type: RuleSearchType, value: string) {
        return this.httpClient.post(`${this.api}/rules/search`, {
            body: { type, value }
        });
    }
}

export const rulesApi = new RulesApi(httpClient);
